export type AbhaResolveMember = {
  id: string
  name: string
  firstName?: string
  dateOfBirth: string
  relation: string
  abhaNumber: string
  abhaAddress: string
  avatarUrl?: string
  abhaCardPng?: string
  gender?: 'male' | 'female'
}

export const ABHA_RESOLVE_TOAST_COPY_SUCCESS = 'ABHA number copied'
export const ABHA_RESOLVE_TOAST_DOWNLOAD_SUCCESS = 'ABHA card downloaded'
export const ABHA_RESOLVE_TOAST_COPY_ERROR = "Couldn't copy. Please try again"
export const ABHA_RESOLVE_TOAST_DOWNLOAD_ERROR = 'Download failed. Please try again'
export const ABHA_RESOLVE_TOAST_PHONE_ERROR = 'Something went wrong! Please try again later'

export const ABHA_RESOLVE_ROUTE = '/new-abha/resolve/'
export const ABHA_RESOLVE_NAVIGATION_SESSION_KEY = 'abhaResolveNavigationState'
export const ABHA_RESOLVE_NAVIGATION_STATE = {
  FROM_RESOLVE: 'from-resolve',
  RETURNED: 'returned',
  CREATED: 'created',
} as const

export const ABHA_RESOLVE_ANALYTICS_EVENTS = {
  VIEW_FAMILY_SCREEN: 'view_abha_for_family_screen',
  ADD_FAMILY_MEMBER: 'tap_add_abha',
  DOWNLOAD_CARD: 'tap_abha_card_download',
  INVITE_FRIENDS: 'tap_invite_friends',
  SELECT_FAMILY_CARD: 'tap_family_abha_card',
  VIEW_PAGE: 'app_view_page',
  INTERACTION: 'tap_btn_interaction',
  TAP_BTN_ENGAGE: 'tap_btn_engage',
} as const

export const ABHA_RESOLVE_ANALYTICS = {
  INAPP_FIRST_LANDING_PAGE: 'inapp_first_landing_page',
  FAMILY_PAGE: 'abha_for_your_family_screen_new',
  LANDING_PAGE: 'abha_landing_page',
  FAMILY_SHEET_PAGE: 'family_members_sheet_abha',
  RELATIONSHIP_ASSIGNMENT_PAGE: 'who_are_these_abha_cards_for',
  FAMILY_MEMBERS_BOTTOM_SHEET_PAGE: 'family_members_bottom_sheet_abha',
  CREATE_PAGE_URL: 'https://www.acko.com/new-abha/create',
  RESOLVE_PAGE_URL: 'https://www.acko.com/new-abha/resolve',
  TYPE: 'vas',
  TITLE: 'Acko | Ayushman Bharat Health Account',
  WEB_FLOW: 'Web Flow',
  ENTRY_POINT: 'homepage',
  CREATION_JOURNEY: 'abha_creation',
  ADD_RELATION: 'add_relation',
  STAGE: {
    HOMEPAGE: 'homepage',
    ABHA_CREATED: 'abha_created',
    ABHA_CREATION_ABANDONED: 'abha_creation_abandoned',
  },
} as const

export const ABHA_RESOLVE_CARD_SHAPE = 'https://acko-cms.ackoassets.com/shape_166ef60bf0.webp'

export const ABHA_RESOLVE_BACK_ICON = 'https://acko-cms.ackoassets.com/arrow_left_b49af00203.svg'

export const ABHA_RESOLVE_DOWNLOAD_ICON = 'https://acko-cms.ackoassets.com/Download_82039e12c5.svg'

export const ABHA_RESOLVE_COPY_ICON = 'https://acko-cms.ackoassets.com/Copy_a2faf8b687.svg'

export const ABHA_RESOLVE_COPY_SUCCESS_ICON = 'https://acko-cms.ackoassets.com/tick_2a81187d36.svg'

export const ABHA_RESOLVE_NHA_LOGO = 'https://acko-cms.ackoassets.com/NHA_logo_eb4a5f968c.svg'

export const ABHA_RESOLVE_INVITE_ILLUSTRATION = 'https://acko-cms.ackoassets.com/ABHA_B_and_W_Cards_2e3824e727.webp'

export const ABHA_RESOLVE_INVITE_ARROW_ICON = 'https://acko-cms.ackoassets.com/arrow_7efac72fc8.svg'

export const ABHA_RESOLVE_FAMILY_SECTION_TITLE = 'Set up ABHA cards for your family'

export const ABHA_RESOLVE_INVITE_TITLE = 'Know someone who needs this?'

export const ABHA_RESOLVE_INVITE_DESCRIPTION = 'Invite your friends and family to create their ABHA cards'

export const ABHA_RESOLVE_INVITE_CTA = 'Invite now'

export const ABHA_RESOLVE_INVITE_DEFAULT_MESSAGE =
  'Hi there!👋 I have invited you to create your ABHA (Ayushman Bharat Health Account) card on the ACKO app. 🏥AIIMS already made the card mandatory, and other hospitals may soon follow. 🔍 It’s quick, secure, and completely free. ✅ Join 71 crore Indians who have already created their ABHA cards! Create Your ABHA Card Now https://acko.in/t/J3zmr5a'

export const ABHA_RESOLVE_LOADING_DURATION_MS = 3000
